import SearchBar from './SearchBar'

export {
  SearchBar,
}



// WEBPACK FOOTER //
// ./src/components/children/SearchBar/index.js